import React from 'react'
import {useCSVReader} from 'react-papaparse';
import ShowImageSmall from "../../../image/show-image-small";
import ProductImageSmall from "./product-image-small";

const UploadedProductsList = ({uploadedProductFields, latestProductsList}) => {

    return (
        <>

            <div className="table-content-container overflow-y-scroll border-y border-gray-400 bg-white">
                <table className="w-full">
                    <thead className="">
                    <tr>
                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Parent
                            Product
                        </th>
                        {uploadedProductFields?.map((productField, rowIndex) => (
                            <th key={`th-${rowIndex}`}
                                className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{productField?.label}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody className="">
                    {latestProductsList?.map((product, rowIndex) => (
                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                            <td className="p-2 border border-gray-400 m-auto">
                                <div>{product?.parent}</div>
                            </td>
                            {uploadedProductFields?.map((productField, columnIndex) => (
                                <td key={`column-${rowIndex}-${columnIndex}`}
                                    className="p-2 border border-gray-400 m-auto">

                                    {productField.attribute === 'image' &&
                                        <div>
                                            <ProductImageSmall imageUrl={product[productField.attribute]}/>
                                        </div>
                                    }

                                    {productField.attribute !== 'image' &&
                                        <>{product[productField.attribute]}</>
                                    }

                                </td>
                            ))}
                        </tr>

                    ))}
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default UploadedProductsList
